// extracted by mini-css-extract-plugin
module.exports = {"editButton":"EditButton_editButton__2pon8"};